import { FIELD_META } from "./identityCoachUtils";
import {
  SHOPPING_FOR_OPTIONS,
  LIFE_ROLE_OPTIONS,
  TECH_RELATIONSHIP_OPTIONS,
} from "../constants/shoppingIdentity";

export function buildSuggestedPrompts(missing = []) {
  const prompts = [];

  if (missing.includes("shoppingFor")) {
    prompts.push(SHOPPING_FOR_OPTIONS[0].label, SHOPPING_FOR_OPTIONS[1].label);
  }
  if (missing.includes("budgetMax")) {
    prompts.push("Around $500", "My max is about $800");
  }
  if (missing.includes("lifeRole")) {
    prompts.push(LIFE_ROLE_OPTIONS[0].label, LIFE_ROLE_OPTIONS[1].label);
  }
  if (missing.includes("techRelationship")) {
    prompts.push(
      TECH_RELATIONSHIP_OPTIONS[0].label,
      TECH_RELATIONSHIP_OPTIONS[2].label,
    );
  }

  return [...new Set(prompts)].slice(0, 4);
}

export function buildIdentityInitialMessage(displayName, completeness) {
  const name = displayName ? ` ${displayName}` : "";
  const missing = completeness?.missing || [];
  const nextField = missing[0];
  const question = nextField ? FIELD_META[nextField]?.question : null;

  if (completeness?.isReady) {
    return {
      role: "assistant",
      content: `Your shopping profile looks complete${name ? `,${name}` : ""}. You can still update anything here.`,
    };
  }

  if (question) {
    return {
      role: "assistant",
      content: `Hi${name}! I'll ask a few quick questions so we can score products accurately for you. ${question}`,
    };
  }

  return {
    role: "assistant",
    content: `Hi${name}! Tell me who you shop for and your typical budget — I'll build your shopping profile from the conversation.`,
  };
}
